var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E2E8F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.9083L21.2764 13.1417C20.6734 11.1 19.6482 9.93333 17.8392 9.93333H15.4874C15.3668 11.275 15.3065 13.4333 15.3668 15.7083L16.9347 15.65C18.0201 15.65 18.4422 14.8917 18.6834 13.725H19.2864V18.45H18.6834C18.4422 17.2833 17.9598 16.525 16.9347 16.4667H15.3668C15.3668 18.1583 15.3668 19.6167 15.4874 20.4917C15.608 21.775 15.9095 22.3 16.8744 22.4167L17.7186 22.475V23H10V22.475L10.6633 22.4167C11.5678 22.3 11.9296 21.7167 12.0503 20.4917C12.1709 18.3917 12.1709 14.0167 11.9899 11.5667C11.8693 10.2833 11.5075 9.75833 10.603 9.64167L10 9.58333V9H22V12.9083Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFCircle);
export default __webpack_public_path__ + "static/media/icon-f-circle.205224fd21e4b6d2cffd5657c04418af.svg";
export { ForwardRef as ReactComponent };